import {EndpointUri} from '../@types/EndpointUri';
import app from './app';
import {getEndpointUri} from './getEndpointUri';
import {getRouteUri} from './getRouteUri';
import {StringArray} from '../@interfaces/types';

type Arg = undefined | EndpointUri | { uri?: EndpointUri } | { route?: string };

let defaultParams: string[] | StringArray<string> | undefined = undefined;

export function withGetUriParams(params: string[] | StringArray<string>, callable: () => string) {
    const originalParams = defaultParams;
    defaultParams = params;
    const result = callable();
    defaultParams = originalParams;

    return result;
}

export default function getUri(...items: Arg[]): string {
    let result = null;
    for (const item of items) {
        if (item == null) {
            continue;
        }

        if (typeof item === 'string') {
            try {
                result = app('url').getRouteByName(item).resolveUrl(defaultParams);
            } catch (e) {
                result = item;
            }

            continue;
        }

        if ('uri' in item && item.uri) {
            let itemUri = item.uri;
            if (defaultParams && typeof itemUri === 'object' && !itemUri.params) {
                itemUri = {
                    ...itemUri,
                    params: defaultParams,
                };
            }

            result = getEndpointUri(itemUri);
        }

        if ('route' in item && item.route) {
            result = getRouteUri({
                route: item.route,
                params: 'params' in item ? item.params : defaultParams
            });
        }

        if (result) {
            break;
        }
    }

    return result ?? '';
}
